import fp from 'lodash/fp';
import React from 'react';

import { connect } from 'Modules/core/redux';
import { Text, Button, cn } from 'Modules/ui';
import { withModalContext, modalClassNames } from 'Modules/core/messaging';
import { translate } from 'Modules/core/i18n';

import styles from './index.module.scss';


const PromptModalComponent = ({ t, dispatch, buttons = [], prompt, modal: { hide } }) => (
    <>
        <div className={cn(modalClassNames.content, styles.content)}>
            <Text component='span'>
                {t(prompt)}
            </Text>
            <div className={cn(modalClassNames.buttons, styles.buttons)}>
                {buttons.map(({ title, action, hideModal = true }, idx) => (
                    <Button
                        key={idx}
                        variant='accent'
                        onClick={() => {
                            if (action)
                                dispatch(action);
                            if (hideModal)
                                hide();
                        }}
                    >
                        {t(title)}
                    </Button>
                ))}
            </div>
        </div>
    </>
);

export const PromptModal = {
    component: fp.pipe(
        withModalContext,
        translate(),
        connect(),
    )(PromptModalComponent),
};
